import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { NullableNumberInput, StrictDateInput } from 'shared/components/fields';
import { todayToUnix } from 'utils';
import { Control } from 'shared/components/fields/control';
import { SettingFullRow } from 'z3k-settings/components/material-utils/settings-card';
import { useUnpackEditingProps, } from 'z3k-settings/components/utils/unpack-props';
export const HistoryMaintenancePerformed = memo(function HistoryMaintenancePerformed(props) {
    const { work_state } = props;
    const mileageEditingProps = useUnpackEditingProps(props, 'mileage');
    const motoHoursEditingProps = useUnpackEditingProps(props, 'moto_hours');
    const dateEditingProps = useUnpackEditingProps(props, 'date');
    const mileage_field = useCallback((input_props) => (_jsx(NullableNumberInput, { ...input_props, step: 50, min: 0 })), []);
    const moto_hours_field = useCallback((input_props) => (_jsx(NullableNumberInput, { ...input_props, step: 1, min: 0 })), []);
    return (_jsxs(SettingFullRow, { alignItems: "flex-start", width: "100%", display: "grid", gap: 1, sx: {
            gridTemplateColumns: 'repeat(auto-fit, minmax(275px, 1fr))',
        }, children: [_jsx(Control, { label: "\u041F\u0440\u043E\u0431\u0435\u0433", ...mileageEditingProps, field: mileage_field, helper_text: work_state != null
                    ? `Текущий: ${Math.ceil(work_state.mileage.user_counted.value)}`
                    : undefined }), _jsx(Control, { label: "\u041C\u043E\u0442\u043E\u0447\u0430\u0441\u044B", ...motoHoursEditingProps, field: moto_hours_field, helper_text: work_state != null
                    ? `Текущие: ${Math.ceil(work_state.moto_hours.user_counted.value)}`
                    : undefined }), _jsx(Control, { label: "\u0414\u0430\u0442\u0430", ...dateEditingProps, value: dateEditingProps.value != null
                    ? dateEditingProps.value
                    : todayToUnix(), field: StrictDateInput })] }));
});
